<div class="flex row p-2 justify-between">
    <div class="text-lg font-medium tracking-tight leading-6 truncate">Create String
    </div>
    <div>
        <button mat-dialog-close>
            <ng-container [ngTemplateOutlet]="closedIcon"></ng-container>
        </button>
    </div>
</div>

<hr class="my-0">

<mat-dialog-content>
    <form [formGroup]="wellStringForm">
        <table class="table editTable">
            <tr>
                <td class="w-2/4 px-3">
                    String Long Name
                </td>
                <td class="w-2/4 px-3">
                    String Short Name
                </td>
            </tr>
            <tr>
                <td class="px-3">
                    <mat-form-field class="w-full">
                        <input matInput placeholder="" formControlName="stringLongName">
                        <mat-error *ngIf="stringLongName.invalid">
                            String Long Name is required
                        </mat-error>
                    </mat-form-field>
                </td>
                <td class="px-3">
                    <mat-form-field class="w-full">
                        <input matInput placeholder="" formControlName="stringShortName">
                        <mat-error *ngIf="stringShortName.invalid">
                            String Short Name is required
                        </mat-error>
                    </mat-form-field>
                </td>
            </tr>
            <tr>
                <td class="w-2/4 px-3">
                    Status
                </td>
                <td class="w-2/4 px-3">
                    Tubing Size
                </td>
            </tr>
            <tr>
                <td class="px-3">
                    <mat-form-field class="w-full">
                        <input matInput placeholder="" formControlName="stringStatus">
                    </mat-form-field>
                </td>
                <td class="px-3">
                    <mat-form-field class="w-full">
                        <input matInput type="number" placeholder="" formControlName="tubingSize">
                        <span matTextSuffix>inch</span>
                    </mat-form-field>
                </td>
            </tr>
            <tr>
                <td class="w-2/4 px-3">
                    String Indicator
                </td>
            </tr>
            <tr>
                <td class="px-3">
                    <mat-form-field class="w-full">
                        <mat-select formControlName="stringIndicatorShortName">
                            <mat-option *ngFor="let stringIndicator of stringIndicatorList" [value]="stringIndicator">
                                {{ stringIndicator }} </mat-option>
                        </mat-select>
                    </mat-form-field>
                </td>
            </tr>
        </table>
    </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button class="btn btn-outline btn-error mx-4" mat-dialog-close>Cancel</button>
    <button class="btn btn-primary" [disabled]="isLoading || wellStringForm.invalid" (click)="createWellString()">
        <span *ngIf="isLoading" class="loading loading-ring loading-sm"></span>
        {{ isLoading ? 'Creating..' : 'Create' }}
    </button>
</mat-dialog-actions>

<ng-template #closedIcon>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
        class="w-6 h-6">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
    </svg>
</ng-template>